import { render, staticRenderFns } from "./knowledge-bank-criteria.vue?vue&type=template&id=279dd56b&scoped=true&"
import script from "./knowledge-bank-criteria.vue?vue&type=script&lang=js&"
export * from "./knowledge-bank-criteria.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-bank-criteria.vue?vue&type=style&index=0&id=279dd56b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279dd56b",
  null
  
)

export default component.exports